angular.module('bribac.views.setPassword', [
  'ngRoute',
  'bribac.values',
  'bribac.translations',
  'bribac.services.routeAuth',
  'bribac.services.api',
  'bribac.validators.equals'
])

  .config(function(
    $routeProvider
  ) {
    // Linked to from the Registration confirmation email.
    $routeProvider.when('/set-password', {
      templateUrl: 'set-password-view.html',
      controller: 'SetPasswordViewCtrl',
      controllerAs: '$ctrl',
      resolve: {access: function(routeAuth) {return routeAuth.requireUnauth()}}
    })

    // Linked to from the Reset forgotten password email.
    $routeProvider.when('/reset-password', {
      templateUrl: 'set-password-view.html',
      controller: 'SetPasswordViewCtrl',
      controllerAs: '$ctrl',
      resolve: {access: function(routeAuth) {return routeAuth.requireUnauth()}}
    })
  })

  .controller('SetPasswordViewCtrl', function(
    $routeParams,
    $q,
    $location,
    api,
    PASSWORD_VALIDATION_REGEX,
    ROLES
  ) {

    var $ctrl = this
    var token = $routeParams.token

    $ctrl.PASSWORD_VALIDATION_REGEX = PASSWORD_VALIDATION_REGEX

    $ctrl.verifyTokenPromise = $q(function(resolve) {
      if (!token) {
        $ctrl.validToken = false
        resolve()
        return
      }

      api.verifyPasswordToken(token)
        .then(
          function success() {
            $ctrl.validToken = true
          },

          function error() {
            $ctrl.validToken = false
          }
        )
        .finally(function() {
          resolve()
        })
    })

    $ctrl.onSubmit = function() {
      var $form = $ctrl.form

      if ($form.$invalid) {
        return
      }

      $form._submitting = true
      $form._submitError = ''

      api.setPassword(token, $ctrl.password)
        .then(
          function success(request) {
            $ctrl.passwordSet = true
            $ctrl.isSubjectRole = request.data.roles.indexOf(ROLES.SUBJECT) > -1

            if (!$ctrl.isSubjectRole) {
              api.login({
                username: request.data.username,
                password: $ctrl.password
              })
                .then(function success() {
                  $ctrl.authenticated = true
                })
                .finally(function() {
                  $form._submitting = false
                })
            }
          },

          function error(request) {
            $form._submitError = request.statusText
          }
        )
    }
  })
